import React from "react";

const ProfileSkeleton = () => {
  return (
    <div className="max-w-4xl mx-auto w-full px-2 sm:px-4 md:px-8 animate-pulse">
      {/* Header Placeholder */}
      <div className="w-full h-32 bg-gray-100 mb-6 rounded-b-3xl" />
      {/* Avatar, Name, Email, Logout Skeleton */}
      <div className="relative flex flex-col items-center -mt-16 mb-6">
        <div className="border-double border-black border-8 rounded-full w-32 h-32 bg-gray-200" />
        <div className="mt-4 flex flex-col items-center gap-2 w-full">
          <div className="h-6 w-40 bg-gray-200 rounded mb-2" />
          <div className="h-4 w-32 bg-gray-200 rounded mb-2" />
          <div className="h-8 w-24 bg-gray-200 rounded mt-2" />{" "}
          {/* Logout button skeleton */}
        </div>
      </div>
      {/* Tabs Skeleton */}
      <div className="flex justify-center mb-6 gap-2">
        <div className="h-8 w-32 bg-gray-200 rounded" />
        <div className="h-8 w-40 bg-gray-200 rounded" />
      </div>
      {/* Envolvement Cards Skeleton Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, idx) => (
          <div
            key={idx}
            className="group relative bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-md"
          >
            {/* Image Container */}
            <div className="relative aspect-video overflow-hidden bg-gray-200 dark:bg-gray-700">
              <div className="absolute top-3 left-3 w-20 h-6 bg-gray-300 dark:bg-gray-600 rounded-full" />
              <div className="absolute top-3 right-3 w-16 h-6 bg-gray-300 dark:bg-gray-600 rounded-full" />
            </div>
            {/* Content Container */}
            <div className="p-4 space-y-3">
              <div>
                <div className="h-6 w-3/4 bg-gray-200 dark:bg-gray-700 rounded" />
                <div className="mt-2 space-y-2">
                  <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-4 w-2/3 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
              </div>
              <div className="flex items-center justify-between pt-2">
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded-full" />
                  <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
                <div className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
              </div>
              <div className="flex items-center pt-3 border-t border-gray-200 dark:border-gray-700">
                <div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full" />
                <div className="ml-3 space-y-2">
                  <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
                  <div className="h-3 w-32 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSkeleton;
